import { NotesActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  notesList: null,
  notesDetail: null,
  saved_Notes: null,
  deleted_Notes: null,
  markedAsReviewed_Notes: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case NotesActionTypes.save_Notes.REQUEST:
    return {
      ...state,
      loading: true,
      saved_Notes: null,
    };
  case NotesActionTypes.save_Notes.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_Notes: payload,
    };
  case NotesActionTypes.get_notesList.REQUEST:
    return {
      ...state,
      loading: true,
      notesList: null,
    };
  case NotesActionTypes.get_notesList.SUCCESS:
    return {
      ...state,
      loading: false,
      notesList: payload,
    };
  case NotesActionTypes.get_notesDetail.REQUEST:
    return {
      ...state,
      loading: true,
      notesDetail: null,
    };
  case NotesActionTypes.get_notesDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      notesDetail: payload,
    };
  case NotesActionTypes.delete_Notes.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_Notes: null,
    };
  case NotesActionTypes.delete_Notes.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_Notes: payload,
    };
  case NotesActionTypes.markedAsReviewed_Notes.REQUEST:
    return {
      ...state,
      loading: true,
      markedAsReviewed_Notes: null,
    };
  case NotesActionTypes.markedAsReviewed_Notes.SUCCESS:
    return {
      ...state,
      loading: false,
      markedAsReviewed_Notes: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/reducers/notesReducer.js